module.exports = __webpack_public_path__ + "assets/images/e4bccf9d38adbb5edc3575e8cff09fe1.png";